import AdminProductFamilyList from '@/components/ProductFamily/AdminProductFamilyList'
import AdminProductFamilyForm from '@/components/ProductFamily/AdminProductFamilyForm'
import AdminProductFamilyDetail from '@/components/ProductFamily/AdminProductFamilyDetail'


let ProductFamilyRouter = [
{
  path: '/admin/productfamily',
  name: 'AdminProductFamilyList',
  component: AdminProductFamilyList,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/productfamily/new',
  name: 'ProductFamilyNew',
  component: AdminProductFamilyForm,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/productfamily/:id/edit',
  name: 'ProductFamilyEdit',
  component: AdminProductFamilyForm,
  meta: {
    requiresAuth: true
  }
}, {
  path: '/admin/productfamily/:id',
  name: 'ProductFamilyDetail',
  component: AdminProductFamilyDetail,
  meta: {
    requiresAuth: true
  }
}]

export default ProductFamilyRouter



// WEBPACK FOOTER //
// ./src/components/ProductFamily/router.js